var map = {
	"./App": 2225,
	"./App.vue": 2225,
	"./assets/flag/Flag_of_Portugal.png": 7822,
	"./assets/flag/a-Austriaaodiliguoqi.png": 8100,
	"./assets/flag/a-Belgiumbilishiguoqi.png": 6894,
	"./assets/flag/a-Danmarkdanmaiguoqi.png": 8600,
	"./assets/flag/a-Finlandfenlanguoqi.png": 8503,
	"./assets/flag/a-Greekxilaguoqi.png": 8186,
	"./assets/flag/a-Holandhelanguoqi.png": 9522,
	"./assets/flag/a-Irelandaierlanguoqi.png": 5717,
	"./assets/flag/a-Italyyidaliguoqi.png": 3546,
	"./assets/flag/a-Norwaynuoweiguoqi.png": 8799,
	"./assets/flag/a-Swedenruidianguoqi.png": 8644,
	"./assets/flag/america.png": 7726,
	"./assets/flag/aodaliya.png": 3402,
	"./assets/flag/bingdao.png": 1030,
	"./assets/flag/canada.png": 6002,
	"./assets/flag/china.png": 6420,
	"./assets/flag/deguoguoqi.png": 5700,
	"./assets/flag/france.png": 342,
	"./assets/flag/maerta.png": 6911,
	"./assets/flag/ruishi.png": 159,
	"./assets/flag/saipulusi.png": 7406,
	"./assets/flag/siluofake.png": 2404,
	"./assets/flag/siluowenniya.png": 5139,
	"./assets/flag/uk.png": 9086,
	"./assets/flag/xibanyaguoqi.png": 1799,
	"./assets/icon/book_icon.png": 8263,
	"./assets/icon/facebook.png": 3659,
	"./assets/icon/google.png": 2012,
	"./assets/icon/telegram.png": 5442,
	"./assets/images/cuiseNot.png": 2301,
	"./assets/images/discount.png": 8109,
	"./assets/images/google_download.png": 6481,
	"./assets/images/ios_download.png": 6919,
	"./assets/images/location.png": 4752,
	"./assets/images/login_bg.png": 168,
	"./assets/images/logo_transparent.png": 5601,
	"./assets/images/menu-cuise.png": 7881,
	"./assets/images/notfoundBg.png": 9465,
	"./assets/images/profile_default.png": 9809,
	"./assets/images/right.png": 9602,
	"./assets/images/search.png": 7561,
	"./assets/images/special.png": 9861,
	"./assets/logo.png": 6949,
	"./components/BrowseComps/BrowseMerchantBox": 1880,
	"./components/BrowseComps/BrowseMerchantBox.vue": 1880,
	"./components/BrowseComps/BrowseSortBox": 4848,
	"./components/BrowseComps/BrowseSortBox.vue": 4848,
	"./components/BrowseComps/TagBar": 2529,
	"./components/BrowseComps/TagBar.vue": 2529,
	"./components/Footer": 4708,
	"./components/Footer.vue": 4708,
	"./components/Header": 2748,
	"./components/Header.vue": 2748,
	"./components/IndexComps/AllEatDescBox": 8413,
	"./components/IndexComps/AllEatDescBox.vue": 8413,
	"./components/IndexComps/AllEatInfoBox": 2111,
	"./components/IndexComps/AllEatInfoBox.vue": 2111,
	"./components/IndexComps/BenefitBox": 3796,
	"./components/IndexComps/BenefitBox.vue": 3796,
	"./components/MenuComps/CartBox": 6356,
	"./components/MenuComps/CartBox.vue": 6356,
	"./components/MenuComps/CategoryBox": 9869,
	"./components/MenuComps/CategoryBox.vue": 9869,
	"./components/MenuComps/MenuBox": 805,
	"./components/MenuComps/MenuBox.vue": 805,
	"./components/PhoneBtn": 7819,
	"./components/PhoneBtn.vue": 7819,
	"./components/Verifition/Verify": 262,
	"./components/Verifition/Verify.vue": 262,
	"./components/Verifition/Verify/VerifyPoints": 2878,
	"./components/Verifition/Verify/VerifyPoints.vue": 2878,
	"./components/Verifition/Verify/VerifySlide": 6443,
	"./components/Verifition/Verify/VerifySlide.vue": 6443,
	"./components/Verifition/api": 5398,
	"./components/Verifition/api/": 5398,
	"./components/Verifition/api/index": 5398,
	"./components/Verifition/api/index.js": 5398,
	"./components/Verifition/utils/ase": 587,
	"./components/Verifition/utils/ase.js": 587,
	"./components/Verifition/utils/util": 6978,
	"./components/Verifition/utils/util.js": 6978,
	"./config": 1073,
	"./config/": 1073,
	"./config/index": 1073,
	"./config/index.js": 1073,
	"./main": 866,
	"./main.js": 866,
	"./request": 7344,
	"./request/": 7344,
	"./request/index": 7344,
	"./request/index.js": 7344,
	"./router": 1120,
	"./router/": 1120,
	"./router/index": 1120,
	"./router/index.js": 1120,
	"./utils/bus": 333,
	"./utils/bus.js": 333,
	"./utils/debounce": 6171,
	"./utils/debounce.js": 6171,
	"./views": 2145,
	"./views/": 2145,
	"./views/404": 3117,
	"./views/404.vue": 3117,
	"./views/browse": 8781,
	"./views/browse.vue": 8781,
	"./views/index": 2145,
	"./views/index.vue": 2145,
	"./views/login": 7110,
	"./views/login.vue": 7110,
	"./views/menu": 4771,
	"./views/menu.vue": 4771,
	"./views/my": 6573,
	"./views/my.vue": 6573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;